import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// True when env is configured. While the data layer is mid-migration this lets
// the app fall back to demo mode cleanly if the backend isn't wired.
export const supabaseConfigured = Boolean(url && anonKey);

// Guard the args so an unconfigured env doesn't throw at import time.
export const supabase = createClient(url || 'http://localhost:54321', anonKey || 'anon');
